import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateVariableOutputData, SetVariableData } from './set-variable-data.model';
import _ from 'lodash';
import {Observable, Subject} from 'rxjs';
import { closeModalOnEscape } from '../modal-dialog/modal-dialog.helper';
import {select, Store} from '@ngrx/store';
import {propertyTypesView} from '../model/views';
import {AppState, Dictionary} from '../model/reducer';
import {PropertyType} from '../plugins/property-type.model';

@Component({
    selector: 'adm4-set-variable-container',
    template: `
    <adm4-create-variable [createVariableData]='data'
                          [header]="header"
                          [variableTypes]="variableTypes$ | async"
                          (variableCreate)='onVariableCreate($event)'
                          (variableSelect)='onVariableSelect($event)'
                          (cancel)='cancelVariableCreation()'></adm4-create-variable>
  `,
    styles: [':host {display: contents;}'],
    standalone: false
})
export class SetVariableContainerComponent implements OnInit, OnDestroy {
  data = inject<SetVariableData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<SetVariableContainerComponent>>(MatDialogRef);
  private readonly store$ = inject<Store<AppState>>(Store);

  header: string;

  public variableTypes$: Observable<Dictionary<PropertyType> | null>;
  private readonly destroyed$: Subject<boolean> = new Subject();

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.addPanelClass('dialog-max-h-full');
  }

  ngOnInit() {
    this.header = this.data.patternTypeProperty ? `Set variable for ${this.data.patternTypeProperty.name}` : 'Set variable';
    closeModalOnEscape(this.dialogRef, this.destroyed$);
    this.variableTypes$ = this.store$.pipe(select(propertyTypesView));

  }

  onVariableCreate(createVariableOutput: CreateVariableOutputData): void {
    this.data.onCreate(createVariableOutput);
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onVariableSelect(selectedVariableName: string): void {
    this.data.onSelect(selectedVariableName);
    this.dialogRef.close();
  }

  cancelVariableCreation(): void {
    if (this.data.onCancel && _.isFunction(this.data.onCancel)) {
      this.data.onCancel();
    }
    this.dialogRef.close();
  }
}
